import React from 'react';
import { AppButton } from '../../../components/AppButton/AppButton';

function BeholderButton() {
    return (
        <AppButton
            id="btnBeholder"
            variant="secondary"
            size="md"
            data-bs-toggle="modal"
            data-bs-target="#modalBeholder"
        >
            Beholder
        </AppButton>
    );
}

export default BeholderButton;
